export async function clipboardWrite(text: string): Promise<void> {
  await navigator.clipboard.writeText(text);
}
